import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { ConfirmationDialogComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';
import { ApplyToAllService } from './apply-to-all.service';

@Component({
  imports: [FormlyModule, MatButtonModule, MatIconModule, MatTooltipModule],
  selector: 'vectronic-formly-formly-apply-to-all',
  template: `
    <div class="container">
      <div class="wrapper">
        <ng-container #fieldComponent></ng-container>
      </div>
      <button
        type="button"
        mat-icon-button
        (click)="applyToAll()"
        color="primary"
        matTooltip="Apply to all configurations"
        [disabled]="formControl.disabled"
      >
        <mat-icon>control_point_duplicate</mat-icon>
      </button>
    </div>
  `,
  styles: [
    `
      .container {
        display: flex;
        place-items: baseline;
      }
      .wrapper {
        flex: 1;
      }
      button.mat-mdc-icon-button.mat-mdc-button-base {
        flex: 0;
      }
    `,
  ],
})
export class FormlyApplyToAllWrapperComponent extends FieldWrapper {
  applyToAllService = inject(ApplyToAllService);
  private dialogService = inject(DialogService);

  applyToAll() {
    this.dialogService.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirm',
        message: `Are you sure you want to apply this value to all configurations?`,
      },
      afterConfirm: () =>
        this.applyToAllService.applyToAll$.next({
          orderInfo: this.formState['orderInfo'],
          key: this.field.key,
          value: this.field.formControl.value,
        }),
    });
  }
}
